'use client'

import useTenant from '@/hooks/useTenant'
import { GoogleTagManager } from '@next/third-parties/google'

const TenantIntegrations = () => {
  const tenant = useTenant()
  return (
    <>
      {tenant.integrations?.googleTagManager?.containerId && (
        <GoogleTagManager gtmId={tenant.integrations.googleTagManager.containerId} />
      )}
    </>
  )
}

export default TenantIntegrations
